import {jsx as _jsx} from "react/jsx-runtime";
export let frontmatter = {
  "title": "Manual de usuario",
  "description": "Guía completa de uso de Orkestria por rol y módulo."
};
export let structuredData = {
  "contents": [],
  "headings": []
};
import {ComingSoon} from "@/components/docs/ComingSoon";
export let toc = [];
function _createMdxContent(props) {
  return _jsx(ComingSoon, {
    title: "Manual de usuario · Próximamente",
    description: "Estamos preparando una guía exhaustiva por rol y módulo. Mientras tanto, puedes preguntarle a Faki cualquier duda sobre el sistema."
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
